type ScheduleNodeDataRecord = Record<string, unknown>

/** Replace legacy and React Flow schedule fields with one current selection. */
export function withScheduleSelection<T extends ScheduleNodeDataRecord>(
  data: T,
  scheduleId: string | undefined,
  scheduleUuid: string | undefined,
): T {
  const nextData: ScheduleNodeDataRecord = { ...data }

  delete nextData.schedule_id
  delete nextData.schedule_uuid
  delete nextData.scheduleId
  delete nextData.scheduleUuid

  if (scheduleId) {
    nextData.scheduleId = scheduleId
  }
  if (scheduleId && scheduleUuid) {
    nextData.scheduleUuid = scheduleUuid
  }

  return nextData as T
}
